import { resolveIdentifier, types } from 'mobx-state-tree';

import OrderShippingOption from '../../OrderShippingOption';

const SelectedShipping = types.model('SelectedShipping', {
  module: types.safeReference(OrderShippingOption),
  pickup_point: types.maybeNull(types.string),
}).actions((self) => {
  return {
    updateSelectedModule({id, options}) {
      self.module = resolveIdentifier(OrderShippingOption, options, id);
    },
    updateSelectedPickupPoint({ id }) {
      self.pickup_point = id;
    }
  }
});

export default SelectedShipping;
